import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import {
  CalcinedClayEmissionQualifyingParams,
  calcinedClayEmissionQualifyingParamsSchema
} from '@/shared/api/EmissionQualifyingParamsModel'
import { SelectGroup } from '@/common'

type FormState = {
  QPD01: {
    value: string | null
  }
}

export default function CalcinedClayQualifyingParamsForm({
  qualifyingParams,
  setQualifyingParams
}: {
  qualifyingParams: CalcinedClayEmissionQualifyingParams
  setQualifyingParams: (params: CalcinedClayEmissionQualifyingParams) => void
}) {
  const { t } = useTranslation()

  const [formState, setFormState] = useState<FormState>({
    QPD01: {
      value: qualifyingParams.QPD01?.value || null
    }
  })

  const onQpd01Change = (evt: React.ChangeEvent<HTMLSelectElement>) => {
    setFormState({
      ...formState,
      QPD01: { value: evt.target.value as 'Calcinated' | 'Not Calcinated' }
    })
  }

  const qpd1 = (
    <SelectGroup
      label={t('emissionQualifyingParams:fields.QPD01.label')}
      hint={t('emissionQualifyingParams:fields.QPD01.hint')}
      name="QPD01"
      value={formState.QPD01.value || ''}
      options={[
        { label: t('common:yes'), value: 'Calcinated' },
        { label: t('common:no'), value: 'Not Calcinated' }
      ]}
      onChange={onQpd01Change}
    />
  )

  useEffect(() => {
    const validationResult = calcinedClayEmissionQualifyingParamsSchema.safeParse(formState)

    if (validationResult.success) {
      setQualifyingParams(validationResult.data)
    }
  }, [formState])

  return (
    <div className="space-y-4">
      <ul className="grid grid-cols-2 gap-4">
        <div className="space-y-2">{qpd1}</div>
      </ul>
    </div>
  )
}
